module.exports = __webpack_public_path__ + "img/16.f55ca513.jpg";